var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-main"},[_c('h3',{staticClass:"c-title c-title--page-section"},[_vm._v(_vm._s(_vm.$t('group.edit')))]),_c('group',{attrs:{"id":_vm.$route.params.groupId},on:{"submit":function($event){return _vm.update($event)},"remove":function($event){return _vm.remove($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }